
import React from "react";
import { useTranslation } from 'react-i18next';
import { PuttingResult } from "@/types/puttingResults";

interface ExerciseStatisticsProps {
  exerciseType: string;
  results: PuttingResult[];
}

const ExerciseStatistics: React.FC<ExerciseStatisticsProps> = ({
  exerciseType,
  results
}) => {
  const { t } = useTranslation('training');
  const totalTests = results.length;
  const averagePoints = Math.round((results.reduce((sum, r) => sum + r.points, 0) / totalTests) * 10) / 10;
  const bestScore = Math.max(...results.map(r => r.points));

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg">
      <h4 className="font-semibold mb-2">{t('results.statistics.title')} - {t(`results.exerciseTypes.${exerciseType}`, { defaultValue: exerciseType })}</h4>
      <div className="grid grid-cols-3 gap-4 text-sm">
        <div>
          <span className="text-gray-600">{t('results.statistics.testsCompleted')}</span>
          <span className="ml-2 font-medium">{totalTests}</span>
        </div>
        <div>
          <span className="text-gray-600">{t('results.statistics.average')}</span>
          <span className="ml-2 font-medium">{averagePoints} {t('results.statistics.points')}</span>
        </div>
        <div>
          <span className="text-gray-600">{t('results.statistics.bestScore')}</span>
          <span className="ml-2 font-medium text-green-600">{bestScore} {t('results.statistics.points')}</span>
        </div>
      </div>
    </div>
  );
};

export default ExerciseStatistics;
